import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export const TrustedCompanies = () => {
  const { t } = useTranslation();
  const [items, setItems] = useState([]);
  useEffect(() => {
    axios.get(`${API}/api/public/trusted-companies`).then((r) => setItems(r.data)).catch(() => {});
  }, []);
  if (!items.length) return null;

  return (
    <section className="bg-white border-b border-slate-100 py-10 sm:py-12" aria-labelledby="trusted-title" data-testid="trusted-companies">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <h2 id="trusted-title" className="text-xs font-semibold tracking-[0.12em] uppercase text-slate-500 mb-6 text-center">
          {t('trusted.title')}
        </h2>
        <ul className="flex flex-wrap justify-center gap-4 sm:gap-6">
          {items.map((c) => {
            const logoSrc = c.logo_url
              ? (c.logo_url.startsWith('/') ? `${API}${c.logo_url}` : c.logo_url)
              : c.logo_data;
            if (!logoSrc) return null;
            return (
              <li
                key={c.id}
                className="rounded-xl border border-slate-200 bg-white p-4 flex items-center justify-center w-32 h-20 sm:w-36 sm:h-24 hover:shadow-md transition-shadow"
                data-testid={`trusted-${c.id}`}
              >
                {c.website ? (
                  <a href={c.website} target="_blank" rel="noopener noreferrer" title={c.name} className="flex items-center justify-center w-full h-full">
                    <img src={logoSrc} alt={c.name} className="max-h-12 max-w-full object-contain grayscale hover:grayscale-0 transition-all duration-300" loading="lazy" />
                  </a>
                ) : (
                  <img src={logoSrc} alt={c.name} className="max-h-12 max-w-full object-contain grayscale" loading="lazy" />
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};
